<template>
	<!-- 添加loading遮罩层 -->
	<div v-loading="isLoading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.8)">
		<div class="home">
			<carousel v-if="configData?.home_banner?.length > 0" :imgList="configData?.home_banner" class="carousel"></carousel>
			<div v-if="newsList?.length > 0" class="news_center">
				<div class="news">
					<div>新闻中心</div>
					<span>NEWS CENTER</span>
				</div>
				<div class="bm bm-ac bm-ver">
					<div class="news-list bm bm-ac bm-pc">
						<div v-for="(item, index) in newsList" :key="index" class="news-item-wrapper">
							<div class="news_item" @click="toDetail(item)">
								<div class="news_img_wrapper">
									<img class="news_img" :src="item.image" alt="" @error="handleImageError">
								</div>
								<div class="news_info bm bm-pj bm-ver">
									<div class="news_text">
										<!-- 标题部分：单行显示，超出显示tooltip -->
										<el-tooltip
											v-if="item?.titleOverflow"
											:content="item?.title"
											placement="top"
										>
											<div class="news_title">
												{{ item?.title }}
											</div>
										</el-tooltip>
										<div
											v-else-if="item?.title"
											class="news_title"
										>
											{{ item?.title }}
										</div>
	
										<!-- 内容部分：两行显示，超出显示tooltip -->
										<el-tooltip
											v-if="item?.contentOverflow"
											:content="item?.content"
											placement="top"
										>
											<div class="news_content">
												{{ item?.content }}
											</div>
										</el-tooltip>
										<div
											v-else-if="item?.content"
											class="news_content"
										>
											{{ item?.content }}
										</div>
	
										<div v-if="item?.publishTime" class="news_date">{{ dayjs(item?.publishTime).format('YYYY-MM-DD') }}</div>
									</div>
									<div class="news_toDetail bm bm-ac bm-pj">
										<span class="news_detail">了解详情</span>
										<img class="news_detail_img" src="@/assets/detail.png" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="news_more" @click="toNews">了解更多</div>
				</div>
			</div>
			<div v-if="navsList?.length > 0" class="content-container">
				<!-- 使用数组动态渲染内容区块 -->
				<template v-for="(section,index) in navsList" :key="index">
					<div :class="['section', { 'section-reverse': section.reverse }]">
						<div v-if="!section?.reverse && section?.image" class="section-img">
							<div class="img_container">
								<img
									:src="section?.image"
									:alt="section?.title"
								>
							</div>
						</div>
						<div v-if="section?.reverse && section?.image" class="section-img-reverse">
							<div class="img_container">
								<img
									:src="section?.image"
									:alt="section?.title"
									class="reverse"
								>
							</div>
						</div>
						<div :class="['section-desc', { 'section-desc-reverse': section.reverse }]">
							<h2 v-if="section?.title">{{ section?.title }}</h2>
							<div v-if="section?.content" :class="{ 'text-right': section?.reverse }">
								<p>{{ section?.content }}</p>
							</div>
							<el-button v-if="section?.url" type="primary" class="more-btn" color="#0055A2" @click="toUrl(section.url)">
								查看更多
								<el-icon class="el-icon--right"><ArrowRight /></el-icon>
							</el-button>
						</div>
					</div>
				</template>
			</div>
			<!-- 暂无数据 -->
			<div v-if="newsList?.length === 0 && navsList?.length === 0 && isLoading === false" class="empty_box bm bm-ver bm-ac bm-pc">
				<img src="@/assets/empty_icon.png" alt="">
				<div class="empty_text">
					暂无数据
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, onMounted, nextTick, computed } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { checkEllipsisAsync } from "@/utils/overflowUtil"
import carousel from '@/components/carousel.vue'
import dayjs from 'dayjs'


// 新闻数据
// const newsList = ref([
// 	{
// 		title: '新闻标题1234567890876543212345678912345678900000',
// 		content: '新闻内容1新闻1234567890876543212345678912345678900111111122222222222222123456232111121',
// 		image: "https://img01.yzcdn.cn/vant/cat.jpeg",
// 		url: "https://img01.yzcdn.cn/vant/cat.jpeg",
// 		date: "2024-06-10",
// 		titleOverflow: false,
// 		contentOverflow: false
// 	},
// 	{
// 		title: '新闻标题2',
// 		content: '新闻内容2',
// 		image: "https://img01.yzcdn.cn/vant/cat.jpeg",
// 		url: "https://img01.yzcdn.cn/vant/cat.jpeg",
// 		date: "2024-06-10",
// 		titleOverflow: false,
// 		contentOverflow: false
// 	},
// 	{
// 		title: '新闻标题3',
// 		content: '新闻内容3',
// 		image: "https://img01.yzcdn.cn/vant/cat.jpeg",
// 		url: "https://img01.yzcdn.cn/vant/cat.jpeg",
// 		date: "2024-06-10",
// 		titleOverflow: false,
// 		contentOverflow: false
// 	}
// ])



// 检查所有溢出
const checkAllOverflow = async () => {
  try {
    // 检查标题溢出（单行）
    const titleResults = await checkEllipsisAsync('.news_title', 1, 300)
    titleResults.forEach((result, index) => {
      if (newsList.value[index]) {
        newsList.value[index].titleOverflow = result.isOverflow
      }
    })

    // 检查内容溢出（两行）
    const contentResults = await checkEllipsisAsync('.news_content', 2, 300)
    contentResults.forEach((result, index) => {
      if (newsList.value[index]) {
        newsList.value[index].contentOverflow = result.isOverflow

        // 调试信息
        console.log(`新闻 ${index + 1}:`, {
          是否溢出: result.isOverflow,
          标题长度: newsList.value[index].title?.length,
          内容长度: newsList.value[index].content?.length,
          内容: newsList.value[index].content.substring(0, 50) + '...'
        })
      }
    })
  } catch (error) {
    console.error('检查省略号时出错:', error)
  }
}

// 在组件挂载时添加resize监听器
onMounted(() => {
	nextTick(() => {
		checkAllOverflow()
	})
	window.addEventListener('resize', handleResize)
})
// 如果需要，可以添加一个方法来重新检查（例如当窗口大小改变时）
const handleResize = () => {
  checkAllOverflow()
}
// 在组件卸载时移除监听器
onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})


const router = useRouter()
// 新闻详情页
const toDetail = (item) => {
	console.log(item, "newsDetail");
	// 将新闻详情存储到store中
	store.setNewsDetail({
		title: item.title,
		date: item.publishTime,
		content: item.richContent,
	})
	router.push({
		path: '/newsDetail',
	})
}
// 新闻列表
const toNews = () => {
	router.push('/news')
}
// 去自己配置的页面
const toUrl = (url) => {
	console.log(url, "url")
	// router.push('/url')
	window.open(url)
}

// 添加loading状态
const isLoading = ref(false)

// 获取配置信息
import { useConfigStore } from "@/stores/index.ts";
const store = useConfigStore()
const configData = computed(() => {
	console.log(store.configData,"store.configData")
	return store.configData
})

// 获取新闻列表
import { getNewsList, getNavsList } from '@/apis'
let newsList = ref([])
let navsList = ref([])

// 定义首页新闻最大显示数量
const MAX_NEWS_ITEMS = 3
// 定义首页导航跳转最大显示数量
const MAX_NAVS_ITEMS = 2

onBeforeMount(async () => {
	isLoading.value = true
	const res = await getNewsList("home_news")
	if(res && res.msgCode === "100") {
		newsList.value = res.responseData?.slice(0, MAX_NEWS_ITEMS)?.map(item => {
			return {
				...item,
				titleOverflow: false,
				contentOverflow: false
			}
		})
	}
	const resNavs = await getNavsList()
	if(resNavs && resNavs.msgCode === "100") {
		navsList.value = resNavs.responseData?.slice(0, MAX_NAVS_ITEMS)?.map((itemNav, index) => {
			return {
				...itemNav,
				reverse: index % 2 === 0 ? false : true
			}
		})
	}
	isLoading.value = false
})

// 图片加载错误处理
const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement;
  // 设置默认图片路径
  target.src = new URL('@/assets/news_default_photo.png', import.meta.url).href;
}

</script>

<style lang="styl" scoped>
.home{
	width 100%
	min-height calc(100% - 70px - 220px)
	background-color #fff
	min-width 1200px
	.carousel{
		width 100%
		height: 0;
  		padding-bottom: 38.46%;
		position: relative;
		:deep(.el-carousel__container) {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
		}
		.carousel_img{
			width: 100%;
    		height: 100%;
			object-fit: cover;
		}
	}
	.news_center{
		width 100%
		background: url('@/assets/背景.png') no-repeat center center
		background-size: cover
		padding 80px 0
		.news{
			text-align center
			margin-bottom 42px
			div{
				color #252525
				font-size 24px
				line-height 24px
				margin-bottom 10px
			}
			span{
				color #C1C1C1
				font-size 12px
				line-height 12px
			}
		}

		.news-list{
			display flex
			justify-content center
			flex-wrap wrap
			gap 42px
			.news-item-wrapper{
				width 320px
				// 确保tooltip正常工作
				.news_title, .news_content {
					cursor: pointer!important;
				}
				.news_item{
					width 100%
					cursor: pointer;
					.news_img_wrapper{
						width 100%;
						height: 0;
						padding-bottom: 64.94%;
						position: relative;
						.news_img{
							position: absolute;
							top: 0px;
							left: 0;
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}
					.news_info{
						width 100%
						min-height 140px
						background-color #fff
						padding 15px 13px
						.news_text{
							.news_title{
								font-size 14px
								line-height 14px
								color #252525
								white-space nowrap
								overflow hidden
								text-overflow ellipsis
								cursor default
								padding 2px 0
								margin 0
								font-weight 600
							}

							.news_content{
								cursor: pointer;
								font-size: 12px
								color: #747474
								line-height: 20px
								margin-top 8px
								/* 两行显示，超出显示省略号 */
								display: -webkit-box
								-webkit-box-orient: vertical
								-webkit-line-clamp: 2
								overflow: hidden
								text-overflow: ellipsis
								word-wrap: break-word
								word-break: break-all
								cursor default
								padding 2px 0
								box-sizing: border-box
								// 确保webkit-box正常工作
								-webkit-box-flex: 1
								// 设置明确的max-height
								max-height: 44px
								// 确保文本截断
								overflow-wrap: break-word
							}

							.news_date{
								font-size: 10px
								color: #ACACAC
								line-height: 18px
								margin-top 6px
							}
						}

						.news_toDetail{
							margin-top 12px
							.news_detail{
								font-size: 12px
								color: #747474
								line-height: 12px
							}
							.news_detail_img{
								width 10px
								height 10px
							}
						}
					}
				}
			}
			@media screen and (min-width: 1500px) {
				gap 60px
				.news-item-wrapper{
					width 380px
				}
			}
		}
		.news_more{
			color #0055A2
			font-size 12px
			padding 5px 35px
			border 1px solid #0055A2
			border-radius: 16px
			margin-top: 56px
			cursor: pointer;
		}
	}
	.content-container {
		width: 1000px
		margin: 0 auto
		padding: 160px 0
	}
	.section {
		margin-bottom: 150px
		background-color: #F7F8FA
		position: relative
		.section-desc {
			padding: 88px 58px 64px 58px
			text-align: left
			background-color: #F7F8FA
			h2 {
				font-size: 24px
				margin-bottom: 1.5rem
				color: #323232
			}
			p {
				line-height: 1.7
				color: #6E6E6E
				font-size: 14px
				margin-bottom: 24px
				width: 343px
			}
			.more-btn {
				width: 110px
				height: 40px
				font-size: 14px
			}
		}
		.section-img {
			width: 498px
			position: absolute
			top: -30px
			right: -53px
			.img_container{
				position: relative
				height: 0
				padding-bottom: 76.92%
				img {
					position: absolute
					top: 0
					left: 0
					width: 100%
					height: 100%
					object-fit: cover
					border-radius: 4px
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.content-container {
			max-width: 900px
			padding: 140px 0
		}
		.section{
			max-width: 900px
			margin: 0 auto 120px
			.section-img {
				width: 440px
				right: -60px
			}
			.section-desc {
				padding: 70px 40px
				width: 380px
				h2 {
					font-size: 22px
				}
				p {
					width: 320px
					font-size: 13px
				}
				.more-btn {
					width: 100px
					height: 36px
					font-size: 13px
				}
			}
		}
	}
	.section-reverse{
		position: relative
		background-color: #F7F8FA
		max-width: 1000px
		margin: 0 auto
		.section-img-reverse {
			width: 498px
			position: absolute
			top: -104px
			left: -44px
			.img_container{
				position: relative
				height: 0
				padding-bottom: 76.92%
				img.reverse {
					position: absolute
					top: 0
					left: 0
					width: 100%
					height: 100%
					object-fit: cover
					border-radius: 4px
				}
			}
		}
		.section-desc-reverse {
			padding: 88px 58px 64px 58px
			text-align: left
			background-color: #F7F8FA
			width: 100%
			height: 100%
			text-align: right
			h2 {
				font-size: 24px
				margin-bottom: 1.5rem
				color: #323232
			}
			div {
				width: 100%
				text-align: right
				display: flex
				justify-content: flex-end
				p{
					line-height: 1.7
					color: #6E6E6E
					font-size: 14px
					margin-bottom: 24px
					width: 343px
					text-align: right
				}
			}
			.more-btn {
				width: 110px
				height: 40px
				font-size: 14px
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.section-reverse{
			max-width: 900px
			.section-img-reverse {
				width: 440px
				left: -40px
				top: -70px
			}
			.section-desc-reverse {
				padding: 70px 40px
				h2 {
					font-size: 22px
				}
				div p {
					width: 320px
					font-size: 13px
				}
				.more-btn {
					width: 100px
					height: 36px
					font-size: 13px
				}
			}
		}
	}
	.empty_box{
		width: 100%;
		height: 100%;
		min-height: 70vh;
	}
}
</style>